import Vue from 'vue';

export default {
    namespaced: true,

    actions: {
        delete({}, id_user) {
            return Vue.$api.delete(`/user/${id_user}`);
        },

        saveTags({}, {id_user, tags}) {
            return Vue.$api.post(`/user/${id_user}/tags`, {tags});
        },

        showPasswordLayer({}, id_user) {
            Vue.$modal.open('change-password', {id_user});
        },

        getExport({}, id_export) {
            return Vue.$api.get(`/export/${id_export}`);
        },

        async activateUsers({}, users) {
            let data = await Vue.$api.post(`/action/activate-user`, {users});
            return data;
        },
    },

};